import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { Toaster } from './components/ui/toaster'
import { ErrorBoundary } from './components/ErrorBoundary'

// Verificar se o elemento root existe
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found. Make sure index.html has a div with id="root"')
}

// Criar root e renderizar a aplicação
ReactDOM.createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
    <Toaster 
      position="top-right"
      toastOptions={{
        duration: 4000,
      }}
    />
  </ErrorBoundary>
)

// Mostrar o app assim que o React montar (remove a tela de loading)
setTimeout(() => {
  document.body.classList.add('app-loaded')
}, 50)